import { render } from "./CxPointPerformanceMonitor.vue?vue&type=template&id=3f0a9f65&scoped=true"
import script from "./CxPointPerformanceMonitor.vue?vue&type=script&lang=js"
export * from "./CxPointPerformanceMonitor.vue?vue&type=script&lang=js"

import "./CxPointPerformanceMonitor.vue?vue&type=style&index=0&id=3f0a9f65&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0a9f65"]])

export default __exports__